import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LandingNavbar } from './sections/LandingNavbar';
import { HeroSection } from './sections/HeroSection';
import { FeaturesSection } from './sections/FeaturesSection';
import { HowItWorksSection } from './sections/HowItWorksSection';
import { PlansSection } from './sections/PlansSection';
import { FooterSection } from './sections/FooterSection';
export function LandingPage() {
    return (_jsxs("div", { className: "min-h-screen bg-background text-foreground", children: [_jsx(LandingNavbar, {}), _jsxs("main", { children: [_jsx(HeroSection, {}), _jsx(FeaturesSection, {}), _jsx(HowItWorksSection, {}), _jsx(PlansSection, {})] }), _jsx(FooterSection, {})] }));
}
